import { useEffect, useState } from 'react';

const KONAMI_CODE = [
  'ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown',
  'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight',
  'KeyA', 'KeyB'
];

export const useKonamiCode = (onSuccess: () => void) => {
  const [sequence, setSequence] = useState<string[]>([]);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Prevent default behavior for arrow keys and A/B keys
      if (KONAMI_CODE.includes(event.code)) {
        event.preventDefault();
      }

      setSequence(prev => {
        const newSequence = [...prev, event.code];
        
        // Check if the new sequence matches the Konami code
        if (newSequence.length === KONAMI_CODE.length) {
          const isMatch = newSequence.every((key, index) => key === KONAMI_CODE[index]);
          
          if (isMatch) {
            setIsActive(true);
            onSuccess();
            return []; // Reset sequence
          } else {
            // If not a match, keep only the last few keys that might be part of the sequence
            return newSequence.slice(-KONAMI_CODE.length + 1);
          }
        }
        
        // If sequence is too long, keep only the last few keys
        if (newSequence.length > KONAMI_CODE.length) {
          return newSequence.slice(-KONAMI_CODE.length);
        }
        
        return newSequence;
      });
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onSuccess]);

  return { isActive, sequence };
};
